import script from "./CTerms.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTerms.vue?vue&type=script&setup=true&lang=ts"

import "./CTerms.vue?vue&type=style&index=0&id=7d3b58f4&lang=less"

const __exports__ = script;

export default __exports__